// The template's /js/script.js initialises Owl carousels on document ready,
// which runs before React has rendered the markup. Components call this after
// mount so the carousel is initialised against the real DOM. Options mirror script.js.
export function initOwlCarousel(selector, options) {
    const $ = window.jQuery;
    if (!$ || !$.fn.owlCarousel) return;

    const $el = $(selector);
    if (!$el.length || $el.hasClass('owl-loaded')) return;

    $el.owlCarousel(options);
}

export const bannerCarouselOptions = {
    loop: true,
    margin: 0,
    nav: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    active: true,
    smartSpeed: 1000,
    autoplay: 6000,
    navText: ['<span class="far fa-long-arrow-alt-right"></span>', '<span class="far fa-long-arrow-alt-left"></span>'],
    responsive: {
        0: { items: 1 },
        600: { items: 1 },
        800: { items: 1 },
        1024: { items: 1 },
    },
};

export const threeItemCarouselOptions = {
    loop: true,
    margin: 30,
    nav: true,
    smartSpeed: 500,
    autoplay: 1000,
    navText: ['<span class="icon-Arrow-Left"></span>', '<span class="icon-Arrow-Right"></span>'],
    responsive: {
        0: { items: 1 },
        480: { items: 1 },
        600: { items: 2 },
        800: { items: 2 },
        1024: { items: 3 },
    },
};
